module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head_portrait clearfix p_background"
  }, [_c('h3', {
    staticClass: "all_title"
  }, [_vm._v("上传新头像")]), _vm._v(" "), _c('section', {
    staticClass: "portrait_container tb_padding container_box"
  }, [_c('p', {
    staticClass: "all_state"
  }, [_c('span', {
    staticClass: "btn btn_issue btn_h"
  }, [_vm._v("浏览图片")]), _vm._v(" "), _c('small', {
    staticClass: "tip_sub_text"
  }, [_vm._v("仅限JPG/PNG格式")])]), _vm._v(" "), _c('div', {
    staticClass: "portrait_box clearfix"
  }, [_c('section', {
    staticClass: "pull-left left"
  }, [_c('div', {
    staticClass: "portrait_img_big"
  })]), _vm._v(" "), _c('section', {
    staticClass: "pull-left right"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("头像预览：")]), _vm._v(" "), _c('div', {
    staticClass: "portrait_small_img"
  }), _vm._v(" "), _c('p', {
    staticClass: "btn_box text-center"
  }, [_c('span', {
    staticClass: "btn btn_submit"
  }, [_vm._v("保存")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn_back"
  }, [_vm._v("取消")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-3cf9f321"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/head_portrait.vue
// module id = 1250
// module chunks = 1